<div class="row coreteam-item">
    <div class="col-sm-2">
    
    </div>
    <div class="col-sm-3">
        <img src="/assets/images/coreteam/edgart.png" width="250px">
    </div>
    <div class="col-sm-7">
    <h4>Edgart Katarahweire</h4>
    Edgart through his vast executive positions in consulting with a bias in information technology,  he brings on board an array of  technical, practical and innovativeness that is much needed in the Boldungu technology. As parent, he  believes that parents are key stake holders to the learning of the child and technology like Boldungu can make the experience enjoyed by both the learner and parent. 
    </div>
    </div>
